module.exports = __webpack_public_path__ + "assets/img/form.f3ed6fee.svg";